// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/components';
import { ConfigProvider, Modal } from 'antd';
import { HelpCircle } from 'lucide-react';
import type React from 'react';
import './SecretCloseWarningModal.less';

export interface SecretCloseWarningModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  className?: string;
}

const SecretCloseWarningModal = ({
  open,
  onConfirm,
  onCancel,
  title,
  message,
  confirmLabel,
  cancelLabel,
  className,
}: SecretCloseWarningModalProps) => (
  <ConfigProvider wave={{ disabled: true }}>
    <Modal
      title={null}
      open={open}
      width={428}
      closable={false}
      footer={null}
      maskClosable={false}
      className={className ? `secret-close-warning-modal ${className}` : 'secret-close-warning-modal'}
      zIndex={2000}
    >
      <div className="secret-close-warning-modal-body">
        <HelpCircle className="secret-close-warning-modal-icon" size={64} strokeWidth={2} />
        <h2 className="secret-close-warning-modal-title">{title}</h2>
        <p className="secret-close-warning-modal-content">{message}</p>
        <div className="secret-close-warning-modal-footer">
          <Button
            type="default"
            label={confirmLabel}
            onClick={onConfirm}
            size="large"
            className="secret-close-warning-confirm-button"
          />
          <Button
            type="primary"
            label={cancelLabel}
            onClick={onCancel}
            size="large"
            className="secret-close-warning-cancel-button"
          />
        </div>
      </div>
    </Modal>
  </ConfigProvider>
);

export default SecretCloseWarningModal;
